"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Ticket operations. */
var TicketImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Ticket class.
   * @param client Reference to the service client
   */
  function TicketImpl(client) {
    (0, _classCallCheck2["default"])(this, TicketImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param portalId (Access Controlled)
   * @param body
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(TicketImpl, [{
    key: "createDocumentLink",
    value: function createDocumentLink(hiveId, fullName, portalId, body, options) {
      var operationArguments = {
        hiveId: hiveId,
        fullName: fullName,
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createDocumentLinkOperationSpec);
    }
  }]);
  return TicketImpl;
}(); // Operation Specifications


exports.TicketImpl = TicketImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var createDocumentLinkOperationSpec = {
  path: "/api/Portals({portalId})/Documents/CreateDocumentLink/{hiveId}/{fullName}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "String"
        }
      }
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body24,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.contentType, Parameters.accept1],
  mediaType: "json",
  serializer: serializer
};